// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BackgroundImage-module--wrapper--533a2d","image":"BackgroundImage-module--image--6f1c7e"};